import React from "react";

import { Box, Flex, Text } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";

export const ProgramaApadrinhamento = ({ data }) => {
  return data ? (
    <Box className="break-page">
      <Flex>
        <Group
          title="Programa de Apadrinhamento"
          bgColor="#DDEBEA"
          mt="15px"
          py="12px"
          mtDivider="5px"
        >
          <Flex mt="17px" direction={"column"} gap="18px">
            <Box>
              <Text as="b">Serviço Mantém Programa de Apadrinhamento? </Text>
              <Text>
                {data.mantemProgramaApadrinhamento === "S" ? "Sim" : "Não"}
              </Text>
            </Box>

            {data.mantemProgramaApadrinhamento === "S" && (
              <Box>
                <Text as="b">
                  Em Caso Positivo, esse Programa se Encontra Inscrito no CMDCA?{" "}
                </Text>
                <Text>
                  {data.programaInscritoCmdca === "S" ? "Sim" : "Não"}
                </Text>
              </Box>
            )}
          </Flex>
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          title="Programa de Apadrinhamento"
          bgColor="#DDEBEA"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
